import React from 'react';
import { NextPage } from 'next';
// Hocks
import withApollo from 'hocs/withApollo';
// Layouts
import Head from 'layouts/Head/Head';
import Header from 'layouts/Header/Header';
import Footer from 'layouts/Footer/Footer';
// Components
import TermsOfServiceContent from 'components/TermsOfService/TermsOfServiceContent/TermsOfServiceContent';

const TermsOfService: NextPage = () => {
  return (
    <>
      <Head
        title="Terms Of Service"
        description="Make money and connect with MILLIONS of fans"
      />
      <Header />
      <TermsOfServiceContent />
      <Footer />
    </>
  );
};

export default withApollo(TermsOfService);
